// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_gU","advertCardNum":"c-a_gV"};